import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { LuPlus } from 'react-icons/lu';
import {
  FaFont,
  FaHeading,
  FaListOl,
  FaListUl,
  FaQuoteLeft,
} from 'react-icons/fa';
import UploadImageModal from 'Containers/Modal/UploadImageModal/UploadImageModal';
import Styles from './AddBlockMenu.module.scss';

const options = {
  'Body Text': {
    icon: FaFont,
    subtitle: 'Body Text',
  },
  'Heading 1': {
    icon: FaHeading,
    subtitle: 'Heading 1',
  },
  'Heading 2': {
    icon: FaHeading,
    subtitle: 'Heading 2',
  },
  'Heading 3': {
    icon: FaHeading,
    subtitle: 'Heading 3',
  },
  'Bulleted List': {
    icon: FaListUl,
    subtitle: 'Bulleted List',
  },
  'Numbered List': {
    icon: FaListOl,
    subtitle: 'Numbered List',
  },
  Quote: {
    icon: FaQuoteLeft,
    subtitle: 'Quote',
  },
  Image: {
    subtitle: 'Image',
  },
};

function AddBlockMenu({ editor, freeStyle }) {
  const [UploadImageModalView, setUploadImageModalView] = useState(false);

  const handleMenuItemClick = (event, index, optionKey) => {
    editor.chain().insertContent(`<p></p>`).focus().run();

    switch (optionKey) {
      case 'Body Text':
        editor.commands.setParagraph();
        break;
      case 'Heading 1':
        editor.commands.setHeading({ level: 1 });
        break;
      case 'Heading 2':
        editor.commands.setHeading({ level: 2 });
        break;
      case 'Heading 3':
        editor.commands.setHeading({ level: 3 });
        break;
      case 'Bulleted List':
        editor.commands.toggleBulletList();
        break;
      case 'Numbered List':
        editor.commands.toggleOrderedList();
        break;
      case 'Quote':
        editor.commands.setBlockquote();
        break;
      case 'Image':
        setUploadImageModalView(true);
        break;
      default:
        break;
    }
  };

  if (freeStyle && editor.isEmpty) {
    return null;
  }

  return (
    <>
      <div className="addBlock">
        <Dropdown>
          <div className={Styles.block_section}>
            <Dropdown.Toggle
              variant="default"
              id="addBlockDropDown"
              className={Styles}
            >
              <span className={Styles.block_section__btn}>
                <LuPlus />
                <span>Add new block</span>
              </span>
            </Dropdown.Toggle>
          </div>

          <Dropdown.Menu>
            {Object.keys(options).map((optionKey, index) => {
              return (
                <Dropdown.Item
                  key={optionKey}
                  onClick={(event) =>
                    handleMenuItemClick(event, index, optionKey)
                  }
                >
                  {optionKey}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {UploadImageModalView && (
        <UploadImageModal
          show={UploadImageModalView}
          onHide={() => {
            setUploadImageModalView(false);
          }}
          editor={editor}
        />
      )}
    </>
  );
}

export default AddBlockMenu;
